import React from "react";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Button, Stack, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

interface NavigationButtonsProps {
  onBack?: () => void;
  onNext?: () => void;
  onSecondary?: () => void;
  nextLabel?: string;
  secondaryLabel?: string;
  nextDisabled?: boolean;
  nextTooltip?: string;
  showBack?: boolean;
  secondaryTooltip?: string;
}

const outlinedPillSx = {
  textTransform: "none",
  borderRadius: "32px",
  fontSize: "16px",
  lineHeight: "24px",
  color: "#071f35",
  borderColor: "#7b92a9",
  bgcolor: "white",
  px: "16px",
  py: "4px",
  maxWidth: "240px",
  "&:hover": { borderColor: "#496682", bgcolor: "#f6f8fc" }
} as const;

const filledPillSx = {
  textTransform: "none",
  borderRadius: "32px",
  fontSize: "16px",
  lineHeight: "24px",
  color: "white",
  bgcolor: "#071f35",
  px: "16px",
  py: "4px",
  maxWidth: "240px",
  "&:hover": { bgcolor: "#0d2e47" }
} as const;

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onBack,
  onNext,
  onSecondary,
  nextLabel = "Next",
  secondaryLabel,
  nextDisabled = false,
  nextTooltip,
  showBack = true,
  secondaryTooltip
}) => {
  return (
    <Stack className="deal-create-v2__nav-buttons" sx={{ gap: "12px" }}>
      <Stack direction="row" alignItems="center" gap="8px" sx={{ width: "100%" }}>
        <Stack sx={{ flex: 1 }}>
          {showBack && onBack && (
            <Typography
              onClick={onBack}
              sx={{
                fontSize: "15px",
                lineHeight: "20px",
                color: "#26a6ae",
                cursor: "pointer",
                width: "fit-content",
                "&:hover": { textDecoration: "underline" }
              }}
            >
              {"< Back"}
            </Typography>
          )}
        </Stack>
        {onSecondary && secondaryLabel && (
          <>
            {secondaryTooltip && (
              <MaterialTooltip title={secondaryTooltip} isShow placement="top" variant="dark">
                <ErrorOutlineIcon sx={{ fontSize: 20, color: "#26a6ae", cursor: "pointer" }} />
              </MaterialTooltip>
            )}
            <Button variant="outlined" onClick={onSecondary} sx={outlinedPillSx}>
              {secondaryLabel}
            </Button>
          </>
        )}
        {onNext && (
          <MaterialTooltip
            title={nextTooltip || ""}
            isShow={!!nextTooltip && nextDisabled}
            placement="top"
            centerText
            variant="dark"
          >
            <span>
              <Button variant="contained" onClick={onNext} disabled={nextDisabled} sx={filledPillSx}>
                {nextLabel}
              </Button>
            </span>
          </MaterialTooltip>
        )}
      </Stack>
    </Stack>
  );
};
